
import React from 'react'
import * as R from 'ramda'
import Moment from 'moment'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import {List, ListItem} from 'material-ui/List'
import ContentAdd from 'material-ui/svg-icons/content/add'


import AgentCard from './AgentCard'
import AgentsFilters from './AgentsFilters'
import YelpResults from 'components/YelpResults'
import ifc from 'components/ifc'
import { sortSevDesc } from 'utils/stuff'


export default (o) => {
	let scrollPos = 0
	return(
		<div
			id="main-content"
			style={{
				marginLeft: (typeof global.md.phone() == 'string')?
						"0"
					: '55px'
			  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"5px":"60px"
			  , overflowY: 'auto'
			  , height: "calc(100vh - 60px)"//(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?'calc(100vh - 60px)': (typeof global.md.tablet() == "string")? 'calc(100vh - 168px)' : 'calc(100vh - 109px)'
			  , width: (o.rightStackOpened)? (typeof global.md.phone() == 'string')? "100%" : "calc(53% - 56px)" : `calc(100% - ${(typeof global.md.phone() == 'string')? "0px" : "53px"})`
			}}
		>
			{(typeof global.md.phone() != 'string')?
				<div
					className="desktop-filters"
					style={{
						marginTop: "0"
					  , height: "97px"
					  , paddingTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0px":"8px"
					}}
				>
					{/*<span
						style={{
							float: "left"
						  , margin: "2px 0 0 1px"
						}}
					>
						Filters:
					</span>*/}
					<AgentsFilters
						filtersUPD={o.filtersUPD}
						agentsFilters={o.agentsFilters}
						data={o.data}
						properties={o.properties}
						switchYelp={o.switchYelp}
						yelpIsOn={o.yelpIsOn}
						updCategoryYelp={o.updCategoryYelp}
						yelpCategory={o.yelpCategory}
					/>
				</div>
				: ""
			}
			{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?

				<div
					style={{
						backgroundColor: "#f7f7f8"
					  , textAlign: "center"
					}}
				>
					{(o.filters)?
							<div>
								<AgentsFilters
									filtersUPD={o.filtersUPD}
									agentsFilters={o.agentsFilters}
									data={o.data}
									properties={o.properties}
									switchYelp={o.switchYelp}
									yelpIsOn={o.yelpIsOn}
									updCategoryYelp={o.updCategoryYelp}
									yelpCategory={o.yelpCategory}
								/>
								<div
									onClick={o.toggleFilt}
									style={{
										height: "55px"
									  , paddingRight: "30px"
									}}
								>
									<span
										className="arrow open"
										style={{
											position: "relative"
										  , right: "0"
										  , display: "inline-block"
										}}
									>

									</span>
								</div>
							</div>
						:<div
							onClick={o.toggleFilt}
						>
							<span
								style={{
									display: "inline-block"
								  , width: "8px"
								  , height: "8px"
								  , margin: "0 5px"
								  , borderRadius: "8px"
								  , backgroundColor: "#b3bdc2"
								}}
							></span>
							<span
								style={{
									display: "inline-block"
								  , width: "8px"
								  , height: "8px"
								  , margin: "0 5px"
								  , borderRadius: "8px"
								  , backgroundColor: "#b3bdc2"
								}}
							></span>
							<span
								style={{
									display: "inline-block"
								  , width: "8px"
								  , height: "8px"
								  , margin: "0 5px"
								  , borderRadius: "8px"
								  , backgroundColor: "#b3bdc2"
								}}
							></span>
						</div>
					}
				</div>
				: ""
			}

			{(typeof global.md.phone() != 'string')?
				<div
					style={{
						fontSize: "20px"
					  , fontWeight: "bold !important"
					  , marginTop: "31px"
					  , color: "#FFF"
					  , position: "fixed"
					  , zIndex: "1000"
					  , top: "-15px"
					  , left: "76px"
					}}
				>
					Agents ({o.count})
				</div>
				: ""
			}

			<List
				style={{
					background: "transparent"
				  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0" : "-14px"
				  , paddingTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0" : "8px"
				  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" :"-12px"
				}}
			>
				{(R.keys(o.agents).length)?
					R.map((agent) => (
						<AgentCard
							key={`project-${agent._id}`}
							agent={agent}
							id={agent._id}
							refTask={o.refTask}
							docUpd={o.docUpd}
							history={o.history}
							openPanel={o.openPanel}
							lastInteracted={o.lastInteracted}
							rightStackOpened = {o.rightStackOpened}
							property={{
								cors: (o.properties[o.property])? o.properties[o.property].cors : undefined
							  , _id: (o.properties[o.property])? o.properties[o.property]._id : undefined
							  , address: (o.properties[o.property])? o.properties[o.property].address : undefined
							}}
							docUpd={o.docUpd}
						/>
				),  sortSevDesc(o.agents, "distance", "rating"))
					: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No agents</p>
				}
			</List>
			<YelpResults
				type="Agent"
			/>
		</div>
	)
}
/*{()=> {
}}*/



// WEBPACK FOOTER //
// ./src/routes/manager/agents/AgentsList.js